module.exports = __webpack_public_path__ + "static/media/persianas.8dd9ac7e.svg";